import React from 'react'
import PropTypes from 'prop-types'
import injectSheet from 'react-jss'
import MediaButton from './MediaButton'
import { MediaStates } from '../../../constants'
import compose from 'recompose/compose'
import pure from 'recompose/pure'
import withStateHandlers from 'recompose/withStateHandlers'

const DIAMETER = 95

const styleSheet = theme => ({
    positionalMediaContainer: {
        position: 'absolute',
        transform: 'translate(-50%, -50%)',
        transition: 'opacity 0.24s ease-in-out',
        display: a => (a.custom_ui ? 'none' : 'flex'),
        justifyContent: 'center',
        alignItems: 'center',
        height: DIAMETER,
        width: DIAMETER,
        opacity: 1,
        [theme.breakpoints.down('sm')]: {
            height: 50,
            width: 50,
        },
        borderRadius: '50%',
        pointerEvents: 'all',
        cursor: 'pointer',
    },
})

const style = injectSheet(styleSheet)

const state = withStateHandlers(
    ({ distance = 1 }) => ({
        distance,
    }),
    {
        handleMouseMove: _ => e => {
            const { clientX, clientY, target } = e
            const { top, width, left, height } = target.getBoundingClientRect()
            const offsetX = (left + width / 2 - clientX) / (DIAMETER / 2)
            const offsetY = (top + height / 2 - clientY) / (DIAMETER / 2)
            const d = Math.sqrt(offsetX * offsetX + offsetY * offsetY)
            // 0 < d < 1
            return { distance: d }
        },
        handleMouseLeave: _ => e => {
            return { distance: 1 }
        },
    }
)

const PositionalMediaButton = ({
    classes,
    state,
    progress,
    onClick,
    isMobile,
    distance,
    handleMouseMove,
    custom_ui,
    handleMouseLeave,
}) => {
    return (
        <div
            className={classes.positionalMediaContainer}
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
            onClick={onClick}
        >
            <ReactiveElement state={state} value={1 - distance} isMobile={isMobile}>
                <MediaButton state={state} progress={progress} />
            </ReactiveElement>
        </div>
    )
}

const reactiveStyle = theme => ({
    tilted: {
        opacity: ({ value, state, isMobile }) =>
            isMobile
                ? [MediaStates.PLAY].includes(state)
                    ? 1
                    : 0
                : [MediaStates.PAUSE, MediaStates.REPLAY].includes(state)
                ? 1
                : value,
    },
})

const ReactiveElement = injectSheet(reactiveStyle)(({ classes, children }) => (
    <div className={classes.tilted}>{children}</div>
))

PositionalMediaButton.propTypes = {
    x: PropTypes.number,
    y: PropTypes.number,
    z: PropTypes.number,
    state: PropTypes.string,
    progress: PropTypes.number,
}

PositionalMediaButton.defaultProps = {
    x: 0,
    y: 0,
    z: 0,
    state: MediaStates.PAUSE,
    progress: 0.0,
    opacity: 1,
}

export default compose(style, state, pure)(PositionalMediaButton)
